import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './config';
import './images';

ReactDOM.render(<App/>, document.getElementById('root'));

